import { IImportHandler } from '../import-handler.interface';
import { WorkspaceSchemaGeneratorService } from '@database/workspace';
import { ErrorCodes, FileModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { WorkspaceRepository } from '@database/central';

export class WorkspaceSchemaGeneratorHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private workspaceSchemaGeneratorService: WorkspaceSchemaGeneratorService,
		private loggingService: LoggingService,
		private workspaceRepository: WorkspaceRepository
	) {}

	public async cleanup(model: FileModel): Promise<void> {
		await this.workspaceRepository.remove(model.workFileId);
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel): Promise<void> {
		try {
			await this.workspaceSchemaGeneratorService.generateSchemas(model);
		} catch (error) {
			this.loggingService.error(ErrorCodes.WorkspaceSchemaGeneratorHandler, error);
			await this.cleanup(model);
			throw error;
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}
}
